export default "__VITE_ASSET__DmlELjP1__"